import { IActionContext } from '@msdyn365-commerce/core';
import { IPredefinedRefinerHandler } from '../predefined-refiners';
import { DisplayTemplate, ProductRefinerValue } from '@msdyn365-commerce/retail-proxy';
import { IProductRefinerHierarchyExt } from '../types';
import { getLocale } from '../attributes/locale';

function mergeValues(values: ProductRefinerValue[], newValue: ProductRefinerValue, label: string): void {
    const existing = values.find(v => v.LeftValueBoundLocalizedString === label);
    if (existing) {
        const existingMin = Number(existing.LeftValueBoundString);
        const existingMax = Number(existing.RightValueBoundString);
        existing.Count = (existing.Count || 0) + (newValue.Count || 0);
        existing.LeftValueBoundString = Math.min(existingMin, Number(newValue.LeftValueBoundString)).toString();
        existing.RightValueBoundString = Math.max(existingMax, Number(newValue.RightValueBoundString)).toString();
    } else {
        values.push({
            ...newValue,
            LeftValueBoundLocalizedString: label,
            RightValueBoundLocalizedString: label
        });
    }
}

export function getHandler(context: IActionContext): IPredefinedRefinerHandler | undefined {
    return {
        apply: (refiner: IProductRefinerHierarchyExt) => {
            if (refiner.__predefinedRefinerApplied) {
                return;
            }

            refiner.DisplayTemplateValue = DisplayTemplate.List;
            refiner.RangeToPredefinedRanges = true;

            const locale = getLocale(context.requestContext.locale);
            const values = refiner.Values || [];

            const fixed = values.reduce<ProductRefinerValue[]>((acc: ProductRefinerValue[], value) => {
                const valueAsNumber = Number(value.LeftValueBoundString);

                if (valueAsNumber === 0 || valueAsNumber === 1) {
                    mergeValues(acc, value, locale.labels.no);
                } else {
                    mergeValues(acc, value, locale.labels.yes);
                }

                return acc;
            }, []);
            refiner.Values = fixed;
            refiner.__predefinedRefinerApplied = true;
        },
        isMatch: (refiner) => {
            const recordId = Number(context.requestContext.app.config?.hkjoottavtaleAttributeRecordId);
            return Number.isFinite(recordId) && refiner.RecordId === recordId;
        }
    };
}
